export default "__VITE_ASSET__DBsLs_WI__"